import React from 'react'

export const ResumeBasicInfo = (props) => {
  return (
    <>
        <h4>{props.location}</h4>
        <h4>{props.phone}</h4>
        <h4><a href={`mailto: ${props.gmail}`}>{props.gmail}</a></h4>
        <h4><a href={props.linkedin}>Linkedin</a></h4>
        <h4><a href={props.github}>Github</a></h4>
    </>
  )
}
